<template>
  <div>
    <van-sticky>

      <van-nav-bar
        :title="$route.query.title+'('+this.countStu+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入姓名或学号关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in students" :key="item.id">
          <van-cell :border="false" :label="item.sgender+' '+item.snum+',等级'+item.ranks" :title="item.sname"
                    :value="'训练时间'+getEtime(item.etime)+'  <--'">
          </van-cell>
          <template slot="right">
            <van-button square type="danger" @click="delStuById(item.sid)" text="刪除"/>
            <van-button square type="primary" @click="stuInfo(item.sname,item.sid,item.ranks,item.etime)" text="详细"/>
          </template>
        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>

    <van-action-sheet v-model="showSheet" :title="sName">
      <div style="margin-top: 50px;margin-bottom: 50px">
        <van-cell :border="false" :title="'俱乐部运动等级'+'('+ranks+')'">
          <van-rate v-model="ranks" color="#2980b9" gutter="10" :count="6"
                    @change="onRankChange(sid,ranks)"/>
        </van-cell>

        <!--        <van-cell title='训练时长(分钟)'>-->
        <!--          <van-stepper v-model="etime" step="30" @change="onEtimeChange" integer/>-->
        <!--        </van-cell>-->
        <van-cell value="训练时长(分钟)">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #right-icon>
            <van-tag plain type="primary" style="margin-right: 5px">{{ etime }}</van-tag>
            <van-button type="warning" @click="addtimeDialogShow=true" size="mini">
              <van-icon name="plus"/>
              添加
            </van-button>
          </template>
        </van-cell>
        <van-tabs v-model="activeIndex">
          <van-tab :title="`训练记录(${TrainRecord.length})`">
            <van-divider
              :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
              训练记录
            </van-divider>
            <van-cell-group title="训练记录">
              <van-cell v-for="item in TrainRecord" :key="item.id" :title="item.vname+'场馆'"
                        :value="'训练时间'+item.etime+'分钟'" :label="item.time"/>
            </van-cell-group>
          </van-tab>
          <van-tab :title="`加时长记录(${ClubAddTimeRecord.length})`">
            <van-divider
              :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
              加时长记录
            </van-divider>
            <van-cell-group title="加时长记录">
              <van-cell v-for="item in ClubAddTimeRecord" :key="item.id" :title="item.title"
                        :value="'加'+item.etime+'分钟'"
                        :label="`操作人:${item.oname} 描述:${item.des} ${new Date(item.createDate).toLocaleString()} `"/>
            </van-cell-group>
          </van-tab>
        </van-tabs>


      </div>
    </van-action-sheet>

    <!--    分页-->
    <van-pagination
      v-model="currentPage"
      :total-items="125"
      :page-count="pageCount"
      :show-page-size="5"
      force-ellipses
      @change="onPageChange"
      style="bottom: 0;position: fixed; width: 100%;padding-top: 20px"
    />
    <van-dialog v-model="addtimeDialogShow" title="添加时长" confirmButtonText="添加" show-cancel-button
                @confirm="addEtime">
      <van-form>
        <van-field
          v-model="addtimeForm.title"
          name="标题"
          label="标题"
          placeholder="标题"
          :rules="[{ required: true, message: '请填写标题' }]"
        />
        <van-field
          v-model="addtimeForm.des"
          rows="2"
          autosize
          label="详细描述"
          type="textarea"
          maxlength="200"
          placeholder="请输入详细描述"
          show-word-limit
        />
        <van-field name="stepper" label="时长">
          <template #input>
            <van-stepper v-model="addtimeForm.etime"/>
          </template>
        </van-field>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  NavBar,
  SwipeCell,
  Cell,
  Button,
  List,
  PullRefresh,
  Toast,
  Dialog,
  Rate,
  Pagination,
  Sticky,
  Search,
  Collapse,
  CollapseItem,
  ActionSheet,
  Divider,
  CellGroup,
  Stepper,
  Field,
  Tab, Tabs, Tag, Icon, Form
} from 'vant';
import {
  GetClubStuListLikeKeyByPage,
  GetClubStuListCountByKey,
  DelStuInClubSelect,
  ModifyStuRankInClubSelect,
  ModifyStuETimeInClubSelect
} from "@/network/stuSelect";
import {GetTrainRecord, GetClubAddTimeRecord, ClubAddTimeRecord} from "@/network/student";

Vue.use(NavBar);
Vue.use(SwipeCell);
Vue.use(Cell);
Vue.use(Button);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Rate);
Vue.use(Pagination);
Vue.use(Sticky);
Vue.use(Search);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(ActionSheet);
Vue.use(Divider);
Vue.use(CellGroup);
Vue.use(Stepper);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Icon);
Vue.use(Form);
export default {
  name: "ClubMember",
  data() {
    return {
      // dialog
      addtimeDialogShow: false,
      addtimeForm: {
        title: "",
        des: "",
        etime: 1,
      },
      //van-tabs
      activeIndex: 2,

      students: [],
      //刷新列表
      refreshing: false,
      loading: false,
      finished: true,

      //统计多少学生
      countStu: 0,

      //搜索框
      searchValue: '',

      //分页
      currentPage: 0,


      //action sheet
      showSheet: false,
      sName: "",
      sid: '',
      ranks: 1,
      etime: 1,
      TrainRecord: [],
      ClubAddTimeRecord: [],

    }
  },
  activated() {
    GetClubStuListCountByKey(this.$route.query.cid, "").then(res => {
      this.countStu = res;
    });
    this.GetClubStuListLikeKeyByPage("");
  },
  computed: {
    pageCount() {
      if (this.countStu % 10 === 0)
        return this.countStu / 10;
      return parseInt(this.countStu / 10) + 1;
    },

  },
  methods: {
    getEtime(etime) {
      return Math.floor(etime / 60) + '小时' + etime % 60 + '分钟'
    },
    onSearch(val) {
      this.GetClubStuListLikeKeyByPage(val);
      GetClubStuListCountByKey(this.$route.query.cid, val).then(res => {
        this.countStu = res;
      });
    },
    onCancel() {
      this.GetClubStuListLikeKeyByPage("");
      GetClubStuListCountByKey(this.$route.query.cid, "").then(res => {
        this.countStu = res;
      });
    },
    onPageChange() {
      this.GetClubStuListLikeKeyByPage(this.searchValue, this.currentPage);
    },
    GetClubStuListLikeKeyByPage(name, page = 1) {
      GetClubStuListLikeKeyByPage(this.$route.query.cid, name, page).then(res => {
        this.students = [];
        this.students.push(...res);
      })
    },
    onClickLeft() {
      this.$router.replace("ClubList");
    },
    delStuById(sid) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelStuInClubSelect(sid).then(res => {
            if (res) {
              this.students = this.students.filter(item => item.sid != sid);
              this.countStu = this.countStu - 1;
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });

    }
    ,
    //refresh
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.refreshing = false;
          this.finished = true
        }
        Toast('刷新成功');
        this.GetClubStuListLikeKeyByPage("");

      }, 1500);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
    },
    onRankChange(sid, ranks) {
      ModifyStuRankInClubSelect(sid, ranks).then(res => {
        if (res.status) {
          for (let i = 0; i < this.students.length; i++) {
            if (this.students[i].sid = sid) {
              this.students[i].ranks = ranks;
              Toast(res.msg);
              return;
            }
          }
        } else {
          Toast(res.msg);
        }
      }).catch(err => {
        Toast('修改失败');
      })
    },
    parseDate(date) {
      if (date >= 10)
        return date;
      return '0' + date;
    },
    stuInfo(sName, sid, ranks, etime) {
      this.sid = sid;
      this.ranks = ranks;
      this.sName = sName;
      this.etime = etime;
      GetTrainRecord(sid).then(res => {
        this.TrainRecord = res;
        for (let i = 0; i < this.TrainRecord.length; i++) {
          let d1 = new Date(parseInt(this.TrainRecord[i].stTime));
          let d2 = new Date(parseInt(this.TrainRecord[i].edTime));
          let time = d1.getFullYear() + '-' + (d1.getMonth() + 1) + '-' + d1.getDate() + ' ' + this.parseDate(d1.getHours()) + ':' + this.parseDate(d1.getMinutes()) + '-' + this.parseDate(d2.getHours()) + ':' + this.parseDate(d2.getMinutes());
          this.TrainRecord[i]['time'] = time;
        }
      })
      GetClubAddTimeRecord(sid).then(res => {
        this.ClubAddTimeRecord = res
      })
      this.showSheet = true;
    },
    onEtimeChange() {
      ModifyStuETimeInClubSelect(this.sid, this.etime).then(res => {
        if (res.status) {
          Toast(res.msg);
        } else {
          Dialog({message: res.msg});
        }
      }).catch(err => {
        Toast('修改失败');
      })
    },
    async addEtime() {
      console.log(this.addtimeForm)
      const res = await ClubAddTimeRecord(this.sid, this.addtimeForm.title, this.addtimeForm.des, this.addtimeForm.etime)
      Toast('添加' + (res.status ? "成功" : "失败"));
    }
  }
}
</script>

<style scoped>

</style>
